// verify-identity.component.ts
import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { interval, Subscription, switchMap } from 'rxjs';

import { PageWrapperComponent } from 'app/components/ui-kit/page-components/page-wrapper/page-wrapper.component';
import { HeavyHeaderComponent } from 'app/components/ui-kit/typography/heavy-header/heavy-header.component';
import { SpinnerComponent } from 'app/components/ui-kit/loaders/spinner/spinner.component';
import { AlertMessageComponent } from 'app/components/ui-kit/alerts/alert-message/alert-message.component';
import { IdvService } from 'app/services/idv.service';
import { TextButtonComponent } from 'app/components/ui-kit/buttons/text-button/text-button.component';
import { holdPls } from 'app/utils/time/timing-utils';
import { UserService } from 'app/services/user.service';
@Component({
  selector: 'app-verify-identity',
  standalone: true,
  imports: [PageWrapperComponent, HeavyHeaderComponent, SpinnerComponent, AlertMessageComponent, CommonModule, TextButtonComponent],
  templateUrl: './verify-identity.component.html',
  styleUrls: ['./verify-identity.component.scss']
})
export class VerifyIdentityComponent implements OnDestroy {
  error: string | null = null;
  activityMessage: string = "Initializing Identity Verification.  Stand by..."
  pollingSub?: Subscription;

  constructor(private idv: IdvService, private router: Router, private userService: UserService) {}

  async ngOnInit() {
    const profile = await this.userService.getUserProfile();
    if (profile?.isHumanVerified === true || profile?.idv?.status === 'verified') {
      this.activityMessage = "You are already verified. Redirecting you. Stand by...";
      this.handleVerifiedUser();
    }
    else {
      this.start()
    }
  }

  private start() {
    this.idv.startVerification().subscribe({
      next: ({ id }) => {
        if (!id) { this.error = 'Missing verification session id'; return; }
        // Optional: console.log('Verification session id =', id);
        this.activityMessage = 'Waiting for verification result...';
        this.pollingSub = interval(3000)
          .pipe(switchMap(() => this.idv.getStatus(id)))
          .subscribe({
            next: ({ status }) => {
              if (status === 'verified') {
                this.pollingSub?.unsubscribe();
                this.handleVerifiedUser();
                this.activityMessage = 'Identity Verified. Updating Account. Stand by...';
              } else if (status === 'requires_input') {
                // user needs to retry; you could show a CTA to restart
                this.activityMessage = 'Unable to Verify Identity. See message below.';
                this.error = 'Verification needs additional input. Please retry.';
              } else if (status === 'canceled') {
                this.activityMessage = 'Unable to Verify Identity. See message below.';
                this.error = 'Verification canceled.';
              }
              // other statuses: 'processing'
            },
            error: () => this.error = 'Unable to check verification status'
          });
      },
      error: (e) => this.error = e?.message || 'Unable to start verification'
    });
  }

  async handleVerifiedUser() {
    await holdPls(1800);
    this.router.navigate(['/onboard/invited-party/aircraft']);
  }

  onClickRetry() {
    window.location.reload();
  }

  ngOnDestroy() {
    this.pollingSub?.unsubscribe();
  }
}
